import { normalize, toString } from 'duration-fns';

/**
 * Converts nanoseconds to ISO 8601 duration format (PT format)
 * Examples:
 * - 3661000000000 ns = 1h 1m 1s = PT1H1M1S
 * - 60000000000 ns = 1m = PT1M
 * - 3000000000 ns = 3s = PT3S
 */
const nanosecondsToISO8601Duration = (nanoseconds: number): string => {
  const NANOSECONDS_PER_SECOND = 1_000_000_000;
  const NANOSECONDS_PER_MILLISECOND = 1_000_000;

  const wholeMilliseconds = Math.floor(nanoseconds / NANOSECONDS_PER_MILLISECOND);
  const { hours, minutes, seconds } = normalize({ milliseconds: wholeMilliseconds });
  let result = toString({ hours, minutes, seconds }, { decimalDelimiter: '.' });

  const fractionalNanoseconds = nanoseconds % NANOSECONDS_PER_SECOND;
  const hasFractionalNanoseconds = fractionalNanoseconds !== 0;

  if (result === 'P0D') {
    if (!hasFractionalNanoseconds) {
      return 'PT0S';
    }

    const fractionalPart = fractionalNanoseconds.toString().padStart(9, '0').replace(/0+$/, '');
    return `PT0.${fractionalPart}S`;
  }

  if (!hasFractionalNanoseconds) {
    return result;
  }

  const fractionalPart = fractionalNanoseconds.toString().padStart(9, '0').replace(/0+$/, '');
  const wholeSeconds = seconds;
  const preciseSeconds = `${wholeSeconds}.${fractionalPart}S`;

  if (result.endsWith('S')) {
    result = result.replace(/(\d+(?:\.\d+)?)S$/, preciseSeconds);
    return result;
  }

  return `${result}${preciseSeconds}`;
};

export default nanosecondsToISO8601Duration;
